// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Label_componentWrapper__MiHRX","new":"Label_new__r++kG","bestseller":"Label_bestseller__luLzL","promotion":"Label_promotion__NbfTA"};